/* SOCKET MATCHERS */

import { SOCKET_ACTION, SOCKET_TOPIC } from 'modules/sockets/constants';

/** @param {import("modules/sockets/types/actions").PutSocketMessageAction} action */
export const closeInterventionSocketMatcher = ({ payload }) =>
  payload?.topic === SOCKET_TOPIC.KANBAN &&
  payload.action === SOCKET_ACTION.INTERVENTION_UPDATE &&
  payload.data?.type === 'CLOSED';

/** @param {import("modules/sockets/types/actions").PutSocketMessageAction} action */
export const deleteInterventionSocketMatcher = ({ payload }) =>
  payload?.topic === SOCKET_TOPIC.KANBAN &&
  payload.action === SOCKET_ACTION.INTERVENTION_UPDATE &&
  payload.data?.type === 'DELETED';

/**
 * @param {import('../types/projections/detailed-intervention').DetailedIntervention} intervention
 */
export const normalizeFinalInvoice = (intervention) => {
  if (intervention.finalInvoice) {
    return {
      finalInvoiceStatus: intervention.finalInvoice.status,
      finalInvoice: {
        medias: [],
        ...intervention.finalInvoice,
      },
    };
  }
  return {};
};
